var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDiagramShapes = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 142,
  height: 40,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#DiagramShapes_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BBBCBC",
  d: "M13.079 33.468c7.223 0 13.079-6.038 13.079-13.487S20.302 6.496 13.078 6.496C5.857 6.495 0 12.533 0 19.982s5.856 13.486 13.079 13.486M128.921 33.468c7.223 0 13.079-6.038 13.079-13.487s-5.856-13.486-13.079-13.486-13.079 6.038-13.079 13.487 5.856 13.486 13.079 13.486M62.377 6.495H36.183v27.01h26.194z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF8201",
  d: "M88.91.89 70.39 19.987l18.522 19.098 18.521-19.098z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "DiagramShapes_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .9h142v38.2H0z"
})))));
export default SvgDiagramShapes;